import { MapResponse } from '@empathy/search-adapter';
import { Result } from '@empathy/search-types';

export const TuandcoResultMapper: MapResponse<any, Result> = (rawResult, result) => {
  const value = rawResult.price
    ? Number.parseFloat(rawResult.price.replace('\,', '.'))
    : null;
  const originalValue = rawResult.oldPrice
    ? Number.parseFloat(rawResult.oldPrice.replace('\,', '.'))
    : null;

  return Object.assign(result, {
    mpn: rawResult.mpn,
    price: {
      value,
      originalValue,
      discount: rawResult.discount
    }
  });
};
